// Screen-reader label for an event tile / row (`title, time, source`).
//
// One definition shared by every place that renders an event (EventTile,
// UpNextRow) so a future change to the announced format lands everywhere at once.

import { parseISO } from 'date-fns'
import type { CalendarEvent } from './typings'
import { timeRange } from './dateFormat'
import { sourceLabel } from './displayMaps'

/** The spoken time portion: `All day` or `9:30 AM – 10:00 AM`. */
export function eventTimeLabel(event: CalendarEvent): string {
  return event.allDay
    ? 'All day'
    : timeRange(parseISO(event.start), parseISO(event.end))
}

/** The full accessible name: `Call: Heath Bertini, 9:30 AM – 10:00 AM, Sales Center`. */
export function eventAccessibleName(event: CalendarEvent): string {
  return `${event.title}, ${eventTimeLabel(event)}, ${sourceLabel(event.source)}`
}
